<template>
  <transition name="modal">
    <div class="inset-x-0 mx-auto"
         :class="[(position === 'relative' && 'absolute'),
                  (position === 'absolute' && 'fixed z-100')]"
         :style="{top:`30px`,width:'fit-content',width:'max-content'}">
      <div class="modal-mask" @click="closableOnClickOutside && $emit('close')"></div>
      <div class="modal-wrapper">
        <div class="p-8 lg:p-12 mx-auto relative
                    bg-block shadow-primaryBlock rounded">
          <div class="absolute right-8 lg:right-12 lg:top-12 modal-close-icon">
            <IconCross @click.native="$emit('close')"
                       class="text-red hover:text-red-light transition duration-200 cursor-pointer"/>
          </div>
          <div>
            <slot name="header"></slot>
          </div>
          <div class="modal-body">
            <slot name="body"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import IconCross from "@/components/icons/IconCross";

export default {
  components: {IconCross},
  props: {
    position: {
      type: String,
      default: 'relative'
    },
    closableOnClickOutside: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    const box = document.querySelector('.modal-wrapper').getBoundingClientRect();
    window.scroll(0, pageYOffset + box.top - 130)
    // console.log(pageYOffset + box.top)

    //todo absolute type modal
    // if (this.position === 'absolute') {
    //   document.querySelector('body').classList.add('overflow-hidden')
    // }
  },
  beforeDestroy() {
    //todo absolute type modal
    // document.querySelector('body').classList.remove('overflow-hidden')
  }
}
</script>

<style lang="scss">
.modal-mask {
  backdrop-filter: blur(10px);
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 1;
  width: 100%;
  min-height: 100%;
  background-color: rgba(45, 76, 94, 0.1);
  display: flex;
  justify-content: center;
}

.modal-wrapper {
  margin: 3rem -1rem;
  width: calc(100% + 2rem);
  position: relative;
  z-index: 101;
}

.modal-container {
  width: 540px;
  background: #F3F5F7;
  border: 1px solid #D3D7DC;
  box-sizing: border-box;
  border-radius: 3px;
  position: relative;
  margin-bottom: 5rem;

  .transaction-edit {
    max-width: 820px;
  }
}

.modal-footer {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 38px;
}

.modal-close {
  position: absolute;
  top: 15px;
  right: 18px;
  cursor: pointer;
}

/*animations*/
.modal-enter {
  .modal-mask {
    opacity: 0;
  }

  .modal-wrapper {
    transform: translateY(100px);
  }
}

.modal-enter-to {
  .modal-mask {
    opacity: 1;
  }

  .modal-wrapper {
    transform: translateY(0px);
  }
}

.modal-enter-active {
  transition: all .2s ease;

  .modal-mask {
    transition: all .2s ease;
  }

  .modal-wrapper {
    transition: all .2s ease;
  }
}

.modal-leave-active {
  opacity: 0;
  animation: fadeOutDown .2s ease;
}

.invest-modal {
  max-width: 800px;
}
</style>